<template>
    <div>
        <b-button variant="primary" @click.prevent="toggleCreate">
            {{ !is_creating ? "Add a new day" : "Cancel" }}
        </b-button>

        <div class="create-day__form-wrapper" v-if="is_creating">
            <b-form @submit.prevent="onSubmit">
                <b-form-group>
                    <label>
                        Date
                    </label>

                    <date-picker 
                        :datestring="form.date" 
                        :config="datepickers.date_config"
                        @changed="(new_date) => {
                            form.date = new_date;
                        }">
                    </date-picker>

                    <label>
                        Start Time
                    </label>

                    <date-picker 
                        :datestring="form.start_time" 
                        :config="datepickers.time_config"
                        @changed="(new_time) => {
                            form.start_time = new_time;
                        }">
                    </date-picker>

                    <label>
                        End Time
                    </label>
                    
                    <date-picker 
                        :datestring="form.end_time" 
                        :config="datepickers.time_config"
                        @changed="(new_time) => {
                            form.end_time = new_time;
                        }">
                    </date-picker>
                </b-form-group>

                <b-button type="submit" variant="primary">
                    Add
                </b-button>
            </b-form>
        </div>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import { SERVER_DATE_FORMAT, SERVER_TIME_FORMAT, LOCAL_DATE_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['eventId'],

        components: {
            DatePicker
        },

        data() {
            return {
                is_creating: false,

                form: {
                    date: null,
                    start_time: null,
                    end_time: null,
                    event_id: this.eventId
                },

                datepickers: {
                    date_config: {
                        format: SERVER_DATE_FORMAT,
                        display_format: LOCAL_DATE_FORMAT
                    },

                    time_config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },

        methods: {
            toggleCreate() {
                this.is_creating = !this.is_creating;
            },

            onSubmit() {
                this.$emit('created', { ...this.form });
                this.is_creating = false;
            }
        }
    }
</script>

<style scoped lang="scss">
    .form-group {
        margin: 0;
    }

    textarea {
        margin-bottom: 10px;
    }

    .create-day__form-wrapper {
        padding: 10px;
        border: 1px solid lightgrey;
    }
</style>